import { Button, makeStyles } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import { useState } from 'react';

const useStyles = makeStyles(theme => ({
  rotate: {
    animation: '$rotate 1.5s linear infinite',
  },
  '@keyframes rotate': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

const AnimatedButton = ({ loading, children, onClick, ...restProps }) => {
  const classes = useStyles();
  const [internalFlag, setInternalFlag] = useState(false);
  const action = () => {
    setInternalFlag(true);
    onClick();
  };

  return (
    <Button
      disabled={loading !== undefined ? loading : internalFlag}
      onClick={action}
      endIcon={(loading !== undefined ? loading : internalFlag) ? <SettingsIcon className={classes.rotate} /> : undefined}
      {...restProps}>
      {children}
    </Button>
  );
};

export default AnimatedButton;
